import {$authHost, $host} from "./index";
import {jwtDecode} from "jwt-decode";

const getTokenUserId = () => {
    try {
        const token = localStorage.getItem("token");
        return token ? Number(jwtDecode(token)?.id) : null;
    } catch (_) {
        return null;
    }
};

const scopedPath = (basePath, userId) => {
    const tokenUserId = getTokenUserId();
    return tokenUserId && Number(userId) === tokenUserId
        ? `${basePath}/me`
        : `${basePath}/${userId}`;
};

export const createGenre = async (genre) => {
    const {data} = await $authHost.post('api/genre', genre)
    return data
}
export const editGenre = async (genre) => {
    const {data} = await $authHost.put('api/genre', genre)
    return data
}
export const delGenre = async (id) => {
    const {data} = await $authHost.delete(`api/genre/${id}`); // Указываем id в URL
    return data;
}
export const fetchGenre = async (params) => {
    const { data } = await $authHost.get('api/genre', { params });
    return data;
}
export const fetchPublicBooks = async (params = {}) => {
    const { data } = await $host.get('api/book/public', { params });
    return data; // { items, count, page, limit, pages }
};
export const fetchPublicGenres = async () => {
    const { data } = await $host.get('api/genre');
    return data;
};
export const fetchTypes = async (types) => {
    const {data} = await $authHost.get('api/booktype', types)
    return data
}
export const updateBookType = async (type) => {
    const {data} = await $authHost.put('api/booktype', type)
    return data
}
export const createBookType = async (type) => {
    const {data} = await $authHost.post('api/booktype', type)
    return data
}
export const createPrice = async (price) => {
    const {data} = await $authHost.post('api/price', price)
    return data
}
export const updatePrice = async (price) => {
    const {data} = await $authHost.put('api/price', price)
    return data
}
export const delPrice = async (id) => {
    const {data} = await $authHost.delete(`api/price/${id}`); // Указываем id в URL
    return data;
}
export const fetchPrices = async (prices) => {
    const {data} = await $authHost.get('api/price', prices)
    return data
}
export const createLanguage = async (language) => {
    const {data} = await $authHost.post('api/language', language)
    return data
}
export const updateLanguage = async (language) => {
    const {data} = await $authHost.put('api/language', language)
    return data
}
export const delLanguage = async (id) => {
    const {data} = await $authHost.delete(`api/language/${id}`); // Указываем id в URL
    return data;
}
export const fetchLanguages = async (languages) => {
    const {data} = await $authHost.get('api/language', languages)
    return data
}
export const createAssType = async (atype) => {
    const {data} = await $authHost.post('api/asstype', atype)
    return data
}
export const updateAssType = async (atype) => {
    const {data} = await $authHost.put('api/asstype', atype)
    return data
}
export const delAssType = async (id) => {
    const {data} = await $authHost.delete(`api/asstype/${id}`); // Указываем id в URL
    return data;
}
export const fetchAssTypes = async (asstypes) => {
    const {data} = await $authHost.get('api/asstype', asstypes)
    return data
}
export const fetchFullInfoAssignmentAndBook = async (id) => {
    const {data} = await $authHost.get('api/assignment/one/' +id)
    return data
}

export const createBook = async (formData) => {
    const { data } = await $authHost.post('api/book/', formData);
    return data;
};

export const updateBook = async (bookId, bookData) => {
    const { data } = await $authHost.put(`api/book/${bookId}`, bookData);
    return data;
};

export const purchaseBookAlwaysOnTop = async (id, days) => {
    const { data } = await $authHost.put(`api/book/${id}/always-on-top`, {days});
    return data;
};

export const updateBookAdmin = async (book) => {
    const {data} = await $authHost.post('api/book', book)
    return data
}

export const delBook = async (id) => {
    const {data} = await $authHost.delete(`api/book/${id}`); // Указываем id в URL
    return data;
}

export const fetchBooksWithParams = async (params = {}) => {
    try {
        const {
            // пагинация
            page = 1,
            limit = 50,

            // поиск
            q,

            // даты (можно number минут или Date)
            created_from,
            created_to,

            // базовые поля/флаги
            status,
            ownerId,
            bookId,
            author,
            paper_back_flag,
            kindle_flag,
            kindle_unlimited_flag,
            hard_cover_flag,
            audio_flag,
            message_flag,
            has_cover_file,
            has_book_file,
            amazon_last_update_older_than_days,
        } = params;

        // helper: Date|number|undefined -> number|undefined (минуты с эпохи)
        const toMinutes = (v) => {
            if (v == null) return undefined;
            if (v instanceof Date) return Math.floor(v.getTime() / 60000);
            if (Number.isFinite(v)) return Number(v);
            return undefined;
        };

        const body = {};

        // пагинация
        if (page)  body.page  = page;
        if (limit) body.limit = limit;

        // поиск
        if (q) body.q = String(q).trim();

        // даты (минуты)
        const cf = toMinutes(created_from);
        const ct = toMinutes(created_to);
        if (Number.isFinite(cf)) body.created_from = cf;
        if (Number.isFinite(ct)) body.created_to   = ct;

        // фильтры
        if (status)   body.status   = status;
        if (author)   body.author   = author;
        if (ownerId)  body.ownerId  = ownerId;
        if (bookId)   body.bookId   = bookId;

        // флаги (передаём как есть — бэкенд сам нормализует true/'true'/1)
        if (message_flag !== undefined)          body.message_flag           = message_flag;
        if (paper_back_flag !== undefined)       body.paper_back_flag        = paper_back_flag;
        if (kindle_flag !== undefined)           body.kindle_flag            = kindle_flag;
        if (kindle_unlimited_flag !== undefined) body.kindle_unlimited_flag  = kindle_unlimited_flag;
        if (hard_cover_flag !== undefined)       body.hard_cover_flag        = hard_cover_flag;
        if (audio_flag !== undefined)            body.audio_flag             = audio_flag;
        if (has_cover_file !== undefined)        body.has_cover_file         = has_cover_file;
        if (has_book_file !== undefined)         body.has_book_file          = has_book_file;
        if (amazon_last_update_older_than_days !== undefined) {
            body.amazon_last_update_older_than_days = amazon_last_update_older_than_days;
        }

        const { data } = await $authHost.post("api/book/params", body);
        return data; // ожидаем { items, count, page, limit, duplicates }
    } catch (error) {
        console.error("Error fetching books with params:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch books");
    }
};

export const fetchBookById = async (bookId) => {
    const payload = await fetchBooksWithParams({ bookId, limit: 1, page: 1 });
      return Array.isArray(payload?.items) ? payload.items[0] || null : null;
};

export const adminCheckAmazonAvailability = async (bookId, payload = {}) => {
    const { data } = await $authHost.post(`api/book/admin/availability-audit/${bookId}`, payload);
    return data;
};

export const adminResolveBookDuplicate = async (payload = {}) => {
    const { data } = await $authHost.post("api/book/admin/resolve-duplicate", payload);
    return data;
};

export const fetchComments = async (_userId) => {
    const { data } = await $authHost.post('api/assignment/comments');
    return data;
};

export const fetchCurrentUserBooks = async (uid, params = {}) => {
    const {data} = await $authHost.get('api/book', {params: {uid, ...params}})
    return data
}

export const fetchCurrentUserAssigns = async (uid) => {
    const {data} = await $authHost.get('api/assignment', {params: {uid}})
    return data
}

export const fetchOwnerAssignmentsByBook = async () => {
    const {data} = await $authHost.get('api/assignment/owner/books')
    return data
}

export const fetchOneBook = async (id) => {
    const {data} = await $authHost.get('api/book/' + id)
    return data
}

export const fetchPublicBookBySlug = async (slug) => {
    const { data } = await $host.get('api/book/public/slug/' + slug);
    return data;
};

export const sendEmailToCustomer = async (mail) => {
    const {data} = await $authHost.post('api/email', mail)
    return data
}

export const sendEmailFromContactPage = async (mail) => {
    const {data} = await $host.post('api/email/contact-page', mail)
    return data
}

export const createAssignment = async (assign) => {
    const {data} = await $authHost.post('api/assignment/create-new-assignment', assign)
    return data
}

export const fetchAssignmentsFullInfo = async (booksGenreId, booksLanguageId, booksPriceId, assTypeId, page, limit, userId, own, freePromo, type, q) => {
    const {data} = await $authHost.get('api/assignment/af', {params: {
            booksGenreId, booksLanguageId, booksPriceId, assTypeId, page, limit, own, freePromo, type, q,
    }})
    return data
} // Используется в библиотеке /af с фильтрами /all без фильтров

export const fetchAssignmentBookSearchSuggestions = async (q, type = "book") => {
    const {data} = await $authHost.get('api/assignment/search-suggestions', {params: {q, type}})
    return data
}

export const fetchAssignmentsAdmin = async (params = {}) => {
    try {
        const {
            // серверная пагинация
            page = 1,
            limit = 50,

            // старые
            assignment_status,
            check_status,
            ownerId,
            reviewer_id,
            bookId,

            // новые
            assignment_id,
            q,
            only_with_link,
            ass_type_id,

            // Created
            created_from,
            created_to,

            // Start
            start_read_date_from,
            start_read_date_to,

            // Report
            publish_rev_date_from,
            publish_rev_date_to,

            // Confirmed
            end_rev_date_from,
            end_rev_date_to
        } = params;

        const query = new URLSearchParams();

        // пагинация
        if (page) query.set("page", page);
        if (limit) query.set("limit", limit);

        // базовые
        if (assignment_status) query.set("assignment_status", assignment_status);
        if (check_status) query.set("check_status", check_status);
        if (ownerId) query.set("ownerId", ownerId);
        if (reviewer_id) query.set("reviewer_id", reviewer_id);
        if (bookId) query.set("bookId", bookId);

        // новые
        if (assignment_id) query.set("assignment_id", assignment_id);
        if (q) query.set("q", q);
        if (only_with_link) query.set("only_with_link", "1");
        if (ass_type_id) query.set("ass_type_id", ass_type_id)

        // диапазоны дат (в МИНУТАХ)
        if (Number.isFinite(created_from)) query.set("created_from", created_from);
        if (Number.isFinite(created_to)) query.set("created_to", created_to);

        if (Number.isFinite(start_read_date_from)) query.set("start_read_date_from", start_read_date_from);
        if (Number.isFinite(start_read_date_to)) query.set("start_read_date_to", start_read_date_to);

        if (Number.isFinite(publish_rev_date_from)) query.set("publish_rev_date_from", publish_rev_date_from);
        if (Number.isFinite(publish_rev_date_to)) query.set("publish_rev_date_to", publish_rev_date_to);

        if (Number.isFinite(end_rev_date_from)) query.set("end_rev_date_from", end_rev_date_from);
        if (Number.isFinite(end_rev_date_to)) query.set("end_rev_date_to", end_rev_date_to);

        // NOTE: путь как у тебя
        const { data } = await $authHost.get(`/api/assignment/adm?${query.toString()}`);

        return data; // может быть { items, count } (после доработки бэка) или { assignments }
    } catch (error) {
        console.error("Error fetching assignments:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch assignments");
    }
};

export const adminAuditStaleAssignments = async (payload = {}) => {
    const { data } = await $authHost.post("/api/assignment/admin/stale-audit", payload);
    return data;
};

export const adminReconcileNegativeBalances = async (payload = {}) => {
    const { data } = await $authHost.post("/api/assignment/admin/negative-balance-reconcile", payload);
    return data;
};

export const fetchUsersAdmin = async (params = {}) => {
    try {
        const {
            page = 1,
            limit = 50,
            q,

            tariff_plan,
            userId,
            ref1Id,
            user_email,

            registration_date, // minutes | Date | undefined
            pay_date,          // minutes | Date | undefined
        } = params;

        const toMinutes = (v) => {
            if (v == null) return undefined;
            if (v instanceof Date) return Math.floor(v.getTime() / 60000);
            if (Number.isFinite(v)) return Number(v);
            return undefined;
        };

        const query = new URLSearchParams();

        // пагинация
        if (page)  query.set("page", String(page));
        if (limit) query.set("limit", String(limit));

        // поиск
        if (q && String(q).trim()) query.set("q", String(q).trim());

        // фильтры (как были)
        if (tariff_plan) query.set("tariff_plan", String(tariff_plan));
        if (userId)      query.set("userId", String(userId));
        if (ref1Id)      query.set("ref1Id", String(ref1Id));
        if (user_email)  query.set("user_email", String(user_email));

        const regMin = toMinutes(registration_date);
        const payMin = toMinutes(pay_date);
        if (Number.isFinite(regMin)) query.set("registration_date", String(regMin));
        if (Number.isFinite(payMin)) query.set("pay_date", String(payMin));

        const { data } = await $authHost.get(`api/user/adm_search?${query.toString()}`);
        return data; // { items, count, page, limit }
    } catch (error) {
        console.error("Error fetching users:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch users");
    }
};

export const fetchAmazonReviewData = async (url) => {
    const { data } = await $authHost.post('/api/assignment/scrape', {
        url
    });
    return data;
};

export const fetchAudibleReviewData = async (url) => {
    const { data } = await $authHost.post(`/api/assignment/scrape-audible`, {
        url
    });
    return data;
}

export const fetchSuggestions = async (keyword, where, before, after) => {
    const { data } = await $authHost.post(`/api/assignment/suggestions`, {
        keyword, where, before, after
    });
    return data;
}

export const fetchAssignmentsForThisBook = async (bookId) => {
    const {data} = await $authHost.get('api/assignment/thisbook/' + bookId)

    return data
}

export const editAssignment = async (assignment) => {
    const {data} = await $authHost.put('api/assignment/update-assignment-data', assignment)
    return data
}

export const markAssignmentLibraryView = async (id) => {
    const {data} = await $authHost.put('api/assignment/update-assignment-data', {
        id,
        library_view: true,
    })
    return data
}

export const purchaseAssignmentAlwaysOnTop = async (id, days) => {
    const {data} = await $authHost.put(`api/assignment/${id}/always-on-top`, {days})
    return data
}

export const editAssignmentAdmin = async (assignment) => {
    const {data} = await $authHost.put('api/assignment/update-assignment-data-admin-only', assignment)
    return data
}

export const preAntiFraudCheckAssignment = async (review) => {
    const {data} = await $authHost.put('api/assignment/pre-anti-fraud-check', review)
    return data
}

export const fetchUserBookRatings = async (userId) => {
    const { data } = await $authHost.get(`api/book/${scopedPath("ratings", userId)}`);
    return data;
};

// GET (админ): получить текущие глобальные настройки
export const fetchGlobalSettings = async (params) => {
    // params — если вдруг захочешь прокидывать query (?foo=bar)
    const { data } = await $authHost.get('api/tech/settings/global', { params });
    return data;
};

export const fetchCurrentPromotions = async (params) => {
    // params — если вдруг захочешь прокидывать query (?foo=bar)
    const { data } = await $authHost.get('api/tech/settings/promotions', { params });
    return data;
};


// PUT (админ): частично обновить/создать глобальные настройки
export const updateGlobalSettings = async (payload) => {
    // передаёшь только те поля, которые хочешь поменять
    const { data } = await $authHost.put('api/tech/settings/global', payload);
    return data;
};

// (опционально) Публичный GET: только то, что нужно для баннера (без auth)
export const uploadDashboardPromotionImage = async (formData) => {
    const { data } = await $authHost.post('api/tech/settings/promotion-image', formData);
    return data;
};

export const fetchPublicGlobalSettings = async () => {
    const { data } = await $host.get('api/tech/settings/global/public');
    return data;
};

export const fetchAssignmentsCountForUser = async (userId) => {
    const { data } = await $authHost.get(`api/assignment/${scopedPath("count", userId)}`);

    return data;
};

export const fetchUserDataById = async (id) => {
    const {data} = await $authHost.get(`api/user/data/${id}`);
    return data;
};

export const getBookDataUrlApi = async (url) => {
    const {data} = await $authHost.post('api/book/grab-book-data-from-amazon', {url})
    return data
};

export const getFullBookDataUrlApi = async (url) => {
    const {data} = await $authHost.post('api/book/grab-full-book-data-from-amazon', {url})
    return data
};

export const getFullProductDataUrlApi = async (url) => {
    const {data} = await $authHost.post('api/book/grab-full-product-data-from-amazon', {url})
    return data
};

export const checkMarketplaceAvailabilityApi = async (payload) => {
    const { data } = await $authHost.post('api/book/check-marketplace-availability', payload);
    return data;
};

export const submitComplaintApi = async (payload) => {
    const { data } = await $authHost.post('api/assignment/submit-complaint', payload);
    return data;
};

export const payDeleteBook = async (bookId) => {
    const { data } = await $authHost.post('api/book/book-pay-delete', { bookId });
    return data;
};

export const lookupBookTransferApi = async (bookId) => {
    const { data } = await $authHost.get(`api/book/transfer/lookup/${bookId}`);
    return data;
};

export const requestBookTransferApi = async (bookId) => {
    const { data } = await $authHost.post('api/book/transfer/request', { bookId });
    return data;
};

export const confirmBookTransferApi = async (transferId, sumCode) => {
    const { data } = await $authHost.post('api/book/transfer/confirm', { transferId, sumCode });
    return data;
};

export const getTargetingForecastApi = async ({ marketplace = null, minQuality = 0 }) => {
    const { data } = await $authHost.post('api/assignment/targeting-forecast', {
        marketplace,
        minQuality
    });
    return data; // { ok: true, estimatedPool, marketplace, minQuality }
};

export const getPriceAdvisorStatsApi = async (payload) => {
    const { data } = await $authHost.post("/api/assignment/price-advisor", payload);
    return data;
};
